export const LOGIN = 'login';
export const LOGOUT = 'logout';